<table class="border-0">
  @for (item of eventlog; track item) {
    <tr class="mobile-text">
      <td class="align-top badge-column"><app-badge-status-display
        [badgeStatus]="convertEventStatusToBadgeStatus(item.eventType)"
      class="badge-status-table-log-mobile"></app-badge-status-display></td>
      <td class="align-top">{{item.occurenceTimestamp | date:'dd-MM-yy HH:mm'}} -
      {{convertEventToTranslatedContent(item)}}</td>
    </tr>
  }
</table>